import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import task01 from "./layouts/task-01/task";

const lesson: Lesson = {
  id: "2e808e29-7ae5-48a2-be88-95b9626c5023",
  publicId: "8",
  name: "Proper frequencies and modes",
  difficulty: 1,
  contentTypes: { audio: false, interactive: true, video: false },

  body: [principle01, task01],
};

export default lesson;
